import { FormikProps } from 'formik';
import { ResourceType } from '../../../types/ResourceType';
import LabelTag from './LabelTag';
import { styled } from '@mui/material/styles';
import { Paper } from '@mui/material';

const PREFIX = 'labelAssignmentForm';
const classes = {
  root: `${PREFIX}-root`,
  pointerCursor: `${PREFIX}-pointerCursor`,
  dropdown: `${PREFIX}-dropdown`,
  name: `${PREFIX}-name`,
};
const StyledPaper = styled(Paper)(({ theme }) => ({
  [`& .${classes.root}`]: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },

  [`& .${classes.pointerCursor}`]: {
    cursor: 'pointer',
  },

  [`& .${classes.name}`]: {
    width: 10,
  },
}));

interface LabelAssignmentProp {
  formRef: FormikProps<any>;
  selectedItem: any;
  resourceType: ResourceType;
}

const LabelAssignment = (props: LabelAssignmentProp) => {
  return (
    <StyledPaper elevation={3} style={{ overflowX: 'auto' }}>
      <form style={{ width: '100%', marginBottom: 20, marginTop: 5, display: 'ruby-text' }}>
        <LabelTag
          enableCustomLabel={false}
          formRef={props.formRef}
          defaultLabels={props.selectedItem?.labelIds}
          disabled={false}
          resourceType={props.resourceType}
          width={380}
        />
      </form>
    </StyledPaper>
  );
};
export default LabelAssignment;
